import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styles from './styles';
export const Tooltip = ({ children, id, containerIdentification, sx }) => {
    const tooltipRef = React.useRef(null);
    const [caretStyle, setCaretStyle] = useState('center');
    useEffect(() => {
        if (!containerIdentification || !tooltipRef?.current)
            return;
        // Find ancestor element (container)
        const container = tooltipRef.current?.closest(containerIdentification)?.getBoundingClientRect();
        if (container) {
            const tooltip = tooltipRef.current.getBoundingClientRect();
            let offset = 0;
            if (caretStyle == 'right')
                offset = tooltip.width / 2;
            else if (caretStyle == 'left')
                offset = -tooltip.width / 2;
            if (container.x + container.width < tooltip.left + tooltip.width + offset) {
                // Overflowing right
                setCaretStyle('right');
            }
            else if (container.x > tooltip.left + offset) {
                // Overflowing left
                setCaretStyle('left');
            }
            else {
                setCaretStyle('center');
            }
        }
    }, [children]);
    return (_jsx(Box, { className: 'tooltip', sx: { ...styles.tooltip, ...styles.caret[caretStyle] }, id: id, ref: tooltipRef, children: _jsx(Box, { sx: sx, children: children }) }));
};
